/* eslint-disable no-restricted-syntax */
import { Feedback } from '@icedesign/base';

import axios from 'axios';
import { createHashHistory } from 'history';

import { formatMessage } from '@/i18n';
import { getToken } from '@/tool/profile';
import { isIE } from '@/tool/tool';

// eslint-disable-next-line no-unused-vars
import { apiUrl, timeout, apiPrefix } from './config';
import ExceptionCodes from './ExceptionCodes';
import { requestCryptoMiddleware, responseCryptoMiddleware } from './middlewares';

export const history = createHashHistory();

// axios.defaults.baseURL = apiUrl;
axios.defaults.baseURL = apiPrefix;
axios.defaults.timeout = timeout;

axios.interceptors.request.use(
  config => {
    // TODO: 这里要不要配合redux统一管理数据加载loading状态？
    const token = getToken();
    if (token) {
      config.headers.token = token;
    }
    config.headers.language = navigator.language || navigator.browserLanguage;

    requestCryptoMiddleware(config);

    // 在IE浏览器内，get请求会从缓存中读取请求结果，所以每次加入一个不通timestamp参数，以保证请求最新;
    if (isIE() && config.method.toLowerCase() === 'get') {
      config.params = {
        ...(config.params || {}),
        timestamp: new Date().getTime(),
      };
    }
    // 2025-11-18 yxd为了解决前端查询输入[ 报400错误 ，加入此段代码把参数进行了url的转码进行测试
    // if (config.params) {
    //   for (const key in config.params) {
    //     // eslint-disable-next-line no-prototype-builtins
    //     if (config.params.hasOwnProperty(key)) {
    //       // 对每个参数值进行编码，避免非法字符
    //       if (config.params[key] !== undefined && config.params[key] !== null) {
    //         config.params[key] = encodeURIComponent(config.params[key]);
    //       }
    //     }
    //   }
    // }
    return config;
  },
  err => {
    console.log(err);
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  response => {
    // console.log('请求返回拦截', response);
    if (response.status === 200 || response.status === '200') {
      // 后面这个200没必要
      if (response.data.resultCode == 0 || !response.data.resultCode) {
        // 下载文件成功时，没有resultCode....
        responseCryptoMiddleware(response);
        return response.data;
      }
      // 10035账户被锁定提醒信息
      if (response.data.resultCode === 10035) {
        Feedback.toast.prompt(
          formatMessage('login.user.lock', '', {
            minutes: response.data.data,
          })
        );
        return Promise.reject(response.data);
      }
      // 10036 提示密码错误次数过多，账户已被锁定
      if (response.data.resultCode === 10036) {
        Feedback.toast.prompt(
          formatMessage('login.user.locked', '', {
            minutes: response.data.data,
          })
        );
        return Promise.reject(response.data);
      }

      // 10037 提示密码错误，剩余尝试次数
      if (response.data.resultCode === 10037) {
        Feedback.toast.prompt(
          formatMessage('login.user.attemptscount', '', {
            count: response.data.data,
          })
        );
        return Promise.reject(response.data);
      }

      // 检查一下是不是已知的错误，如果是的话直接使用翻译（所以ExceptionCodes里的内容没有翻译）
      const knownError = ExceptionCodes[response.data.resultCode]
        ? formatMessage(`${response.data.resultCode}`)
        : undefined;
      // 如果后续reject回调中有新Feedback提醒，则会把这里覆盖掉;
      Feedback.toast.error(knownError || `${formatMessage('request.error')}${response.data.msg}`);
      return Promise.reject(response.data);
    }
    // TODO: 这里后期继续观测一下可能出现的值，并做相关处理
    Feedback.toast.error(formatMessage('request.trouble') + response.status);
    // throw Error(response.msg || '服务异常')
    // TODO: 这里是不是应该返回response.data?
    return Promise.reject(response);
  },
  err => {
    // TODO: 处理与服务器断开连接的异常
    // err 由 code 和 message 组成
    const errCode = err.code;
    const errMessage = err.message;
    const errResponse = err.response;
    console.log('errCode:', err.code, 'errMessage:', err.message, 'errResponse:', err.response);
    // 这里捕获一下超时异常;
    // code : ECONNABORTED , message = timeout of Xms exceeded ， response = undefind
    if (errCode == 'ECONNABORTED' && errMessage.includes('timeout')) {
      // 这里是不是用通知栏更好？
      Feedback.toast.error(formatMessage('request.timeout'));
    }
    if (errMessage == 'Network Error') {
      // TODO: 这里需不需要跳转到一个单独的网络错误的页面？
      Feedback.toast.error(formatMessage('request.network.error'));
    }
    // 貌似一般的错误情况下，code = undefined？
    if (errResponse) {
      switch (errResponse.status) {
        // 生产环境下无法连接至服务器时发生的错误
        case 400:
          Feedback.toast.error(formatMessage('request.unconnect'));
          break;
        // Token过期，为空，伪造（错误）
        case 401:
          // TODO: 这里正常也分为三种情况， 详情见ExceptionCodes;
          // 如果存在token则代表曾经登录过，这个时候要给用户提示;
          // 如果不存在token说明是首次登录，直接跳转登录页面不需要提示
          if (getToken()) {
            // TODO: 这个判断逻辑需要优化，因为ExceptionCodes里面都是中文，在本地文件里面已经进行了翻译
            const knownError = ExceptionCodes[errResponse.data.resultCode]
              ? formatMessage(`${errResponse.data.resultCode}`)
              : undefined;
            Feedback.toast.error(knownError || formatMessage('request.login.expired'));
          }
          // TODO:
          // 这里好像也可以使用react-router-redux库来进行优化？
          history.replace('/login');
          break;

        // Token身份认证通过，但是没有权限
        case 403:
          // 一般不会进入到这里的出流程，因为已经对相关页面进行了权限认证，在没有网络请求前就已经进入了403页面
          // 这样可以保证及时编写的权限有一些问题，进行无权限的请求后还是最终会到403页面
          // 这里返回的errResponse.data.resultCode = 40001
          // Feedback.toast.error(`你没有相关权限...`);
          // 没有权限应该push还是replace？
          history.push('/exception/403');
          break;
        case 404:
          history.push('/exception/404');
          break;
        // 内部服务器错误
        case 500:
          // Feedback.toast.error(`服务器内部出现异常，请稍后重试...`);
          // TODO: 是否有必要验证在有token的情况下才跳转500？可以避免一次多余的跳转（到500再回到登陆）
          // if (getToken())
          history.push('/exception/500');
          break;
        case 504:
          // 在开发模式下proxy代理解决跨域无法连接到服务器时产生的错误
          // TODO: translate
          // 生产模式下也有可能会遇到此问题；
          Feedback.toast.error(`${formatMessage('request.gateway.timeout')}`);
          break;
        default:
          Feedback.toast.error(
            `${formatMessage('request.unknown.error')} (${errResponse.data.message})`
          );
          break;
      }
    }
    // 这里返回null，然后在各个接口的错误回调里判断err是否为空，目的是为了在非200返回码下防止读取resultCode做后续处理出错...
    return Promise.reject(null);
  }
);

export { axios };

export default class Http {
  static get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params,
          // 个别长时间才响应的接口需要手动指定timeout超时时间，下方的post、upload同理
          timeout: params?.timeout,
          // paramsSerializer: queryParams => {
          //   return new URLSearchParams(queryParams).toString();
          // },
        })
        .then(
          res => {
            // TODO: 这是最好先判断res，如果请求的数据状态code不符合规范（即没有return response）,res会被拦截，则res为undefined
            // if (res) {
            // console.log('GET ' + url, res);
            resolve(res.data);
            // }
          },
          err => {
            console.log(err);
            reject(err);
            // throw err;
          }
        );
    });
  }

  static post(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          timeout: data?.timeout,
          // headers: {
          //   'Content-Type': 'application/x-www-form-urlencoded',
          // }
        })
        .then(
          res => {
            // console.log('POST ' + url, res);
            resolve(res.data);
          },
          err => {
            console.log(err);
            reject(err);
          }
        );
    });
  }

  // 用于接收List类型参数的Post请求，超时时间可单独传参
  static postLongtime(url, data, timeout) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          timeout,
        })
        .then(
          res => {
            resolve(res.data);
          },
          err => {
            console.log(err);
            reject(err);
          }
        );
    });
  }

  static put(url, data, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, data, {
          params,
        })
        .then(res => {
          // console.log('put res',res);
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static patch(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(url, data)
        .then(res => {
          // console.log('put res',res);
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static delete(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(url, { params }).then(
        res => {
          // console.log('DELETE ' + url, res);
          resolve(res.data);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  // static options(url) {
  //   return new Promise((resolve, reject) => {

  //   })
  // }

  static download(url, params, filaname) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params,
          timeout: 20 * 60 * 1000,
          responseType: 'blob', // 或者使用arraybuffer，但是下载出错的处理方式需要重写;
        })
        .then(
          res => {
            // console.log(res);
            // 返回的不是blob数据，而是json，代表出错了
            // 错误处理参考：https://github.com/axios/axios/issues/815
            if (res.type === 'application/json') {
              // 读取内容，转为json进行错解析
              const reader = new FileReader();
              reader.readAsText(res);
              reader.addEventListener('loadend', () => {
                const resErrJson = JSON.parse(reader.result);
                const knownError = ExceptionCodes[resErrJson.resultCode]
                  ? formatMessage(`${resErrJson.resultCode}`)
                  : undefined;
                Feedback.toast.error(
                  knownError || `${formatMessage('request.unknown.error')} ${resErrJson.msg}`
                );
                reject(resErrJson);
              });
            } else {
              // 正常返回blob数据，准备进行下载;
              const blob = new Blob([res], {
                //   //这么写居然同时支持了excel，pdf和csv？居然还支持zip？？？
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
              });
              // 针对不同浏览器，下载方式是不一样的
              // refer to : https://stackoverflow.com/questions/37522011/permission-denied-for-clicking-link-in-internet-explorer-11
              // IE
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filaname);
              } else {
                // Chrome,Firefox,etc...
                const link = document.createElement('a');
                link.style.display = 'none';
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', filaname);
                document.body.appendChild(link);
                // TODO: 上方链接中说明在firefox中不支持click()?需要改造HTMLElment.prototype，
                // 实际测试中支持，后期再进行观察
                link.click();
              }
              // TODO: 未和其他封装接口保持统一（取data值）；
              resolve(res);
            }
          },
          err => {
            reject(err);
          }
        );
    });
  }

  static upload(url, data, e) {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    return new Promise((resolve, reject) => {
      axios
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: data?.timeout,
        })
        .then(
          res => {
            // TODO: 未和其他封装接口保持统一（取data值）；
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  static downloadByLink(url, params, filename) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params,
          timeout: params?.timeout,
        })
        .then(
          res => {
            const linkDOM = document.createElement('a');
            linkDOM.style.display = 'none';
            linkDOM.setAttribute('href', res.data);
            linkDOM.setAttribute('download', filename);
            linkDOM.click();
            linkDOM.remove();
            resolve();
            // }
          },
          err => {
            console.log(err);
            reject(err);
            // throw err;
          }
        );
    });
  }
}
